/* @flow strict */

import * as React from 'react';
import ConnectForm from './connectForm';

type PropsType = {
  isLoading: boolean,
  enable: boolean,
  username: string,
  connect: () => void,
  disconnect: () => void
};

const MailchimpConnect = ({
  isLoading,
  enable,
  username,
  connect,
  disconnect
}: PropsType): React.Element<'div'> => {
  const [isModalOpen, setModalOpen] = React.useState(false);

  return (
    <div>
      <div
        className="text-center embed-container"
      >

        {isLoading && <div className='csspinner' />}
        <div style={{ marginTop: '60px' }}>
          {enable ?
            <>
              <div className="text-center">
                <a
                  className="btn btn-pink"
                  data-bind="click:login"
                  onClick={(e: any) => {
                    e.preventDefault();
                    disconnect();
                  }}
                >Disconnect Mailchimp</a>
              </div>
              <p
                style={{
                  margin: '30px auto',
                  maxWidth: '720px'
                }}
                data-bind="i18n:$L.connect_facebook_not_permission"
              >
                Your Sparxo account is connected to your Mailchimp account: <b>{username}</b>
                <br /> <br />
                Sync all guests to a Mailchimp list by configuring settings in Account sync settings. <br />
                Sync emails specific events to seporate Mailchimp lists by configuring Mailchimp settings for a specific event when managing an event.
              </p>
            </>
            :
            <>
              <div className="text-center">
                <a
                  className="btn btn-pink"
                  data-bind="click:login"
                  onClick={(e: any) => {
                    e.preventDefault();
                    setModalOpen(true);
                  }}
                >Enable Mailchimp Sync</a>
              </div>
              <p
                style={{
                  margin: '30px auto',
                  maxWidth: '720px'
                }}
                data-bind="i18n:$L.connect_facebook_not_permission"
              >
                Click Enable Mailchimp Sync to connect Sparxo to Mailchamp. You will need to create an <a href='https://mailchimp.com/help/about-api-keys/' target='_blank'>API key</a>.
                <br /> <br />
                With Mailchimp Sync, you can sync all guests with a Mailchimp list by selecting Account sync setting.
                You can also sync an event guestlist with a Mailchimp list by going into Mailchimp setting when manageing an event.
              </p>
            </>
          }
        </div>
      </div>
      {
          isModalOpen &&
          <ConnectForm
            isOpen={isModalOpen}
            handleClose={(): void => setModalOpen(false)}
            handleConnect={connect}
          />
        }
    </div>
  );
};

export default MailchimpConnect;